import Indicator from '../Indicator';

/** WMA indicator */
export default class WMAIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} name - Indicator name
	 * @property {string} id - Indicator ID
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs
	 * @property {object[]} componentSeries - Indicator component series
	 */
	_getDefaultParams() {
		return {
			name: 'WMA',
			id: 'wma',
			description:
				'Moving Averages are trend indicators that smooth stock price movements. Comparing the moving averages from multiple time frames can help investors spot changes in trend. Like the EMA, Weighted Moving Averages place greater emphasis on more recent periods.',
			inputs: [{ name: 'period', value: 20 }],
			componentSeries: [{ id: 'wma' }]
		};
	}

	/**
	 * Renders the line marker
	 * @param {object} data - Symbol data object
	 * @property {string} sessionType - Session type (eg. NormalSession, SessionBreak)
	 */
	render(data, sessionType) {
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
